import { Center, Loader, Paper, Table, Text, Title, createStyles } from "@mantine/core"
import { formatDateTime } from "@medplum/core";
import { Loading, StatusBadge, useMedplum } from "@medplum/react";
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom";


const useStyles = createStyles((theme) => ({
    table: {
        marginTop: "30px"
    },
    thead: {
        backgroundColor: '#BEDEF8',
        borderRadius: 4,
    },
}));

const sampleData = [
    {
        name: "disprin",
        category: "Pain",
        status: "Active",
        startDate: new Date().toDateString(),
        noOfRepeats: 15,
        id: "124211"
    }
]
interface Props {
  pName: any;
}
export const Medication: React.FC<Props> = ({ pName }) => {
  const { patientId } = useParams();
  const { classes } = useStyles();
  const navigate = useNavigate();
  const medplum = useMedplum();
  const [medications, setMedications] = useState<any>([]);
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const tableHeaders = [
    "Medication Name",
    "Priority",
    "Status",
    "Start Date",
    "No of Repeats",
  ];

  useEffect(() => {
    getImmunization();
  }, [patientId]);

  const getImmunization = async () => {
    setIsFetching(true);
    const res = await medplum.searchResources(
      "MedicationRequest",
      `patient=Patient/${patientId}`
    );
    setMedications(res);
    setIsFetching(false);
  };

  return (
    <>
      <Paper
        sx={{
          marginTop: "20px",
          borderRadius: "8px",
          marginLeft: "0px",
          marginRight: "0px",
          padding: "20px",
          background: "'#FFF",
          boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
        }}
        withBorder
      >
        <Title>Medications</Title>
        {!isFetching && (
          <Table className={classes.table}>
            <thead className={classes.thead}>
              <tr>
                {tableHeaders.map((val) => {
                  return <th key={val}>{val}</th>;
                })}
              </tr>
            </thead>
            {
              <tbody>
                {medications.map((med: any) => (
                  <tr
                  style={{cursor:"pointer"}}
                    key={med?.id}
                    onClick={() => {
                      navigate(`/admin/medications/${med?.id}?name=${pName}`);
                    }}
                  >
                    <td>{med?.medicationReference?.display?.toUpperCase()}</td>
                    <td>{med.priority}</td>
                    <td>
                      <StatusBadge status={med.status as string} />
                    </td>
                    <td>{formatDateTime(med.authoredOn as string)}</td>
                    <td>
                      {med.dosageInstruction
                        ? med.dosageInstruction[0].text
                        : ""}
                    </td>
                  </tr>
                ))}
              </tbody>
            }
          </Table>
        )}
        {medications?.length === 0 && !isFetching && (
          <Center style={{ width: "100%", height: "200px" }}>
            <Text size="xl" color="dimmed">
              No results
            </Text>
          </Center>
        )}
        {isFetching && (
          <Center style={{ width: "100%", height: "200px" }}>
            <Loader />
          </Center>
        )}
      </Paper>
    </>
  );
};